(() => {
  function initialize(scope = document) {
    scope.querySelectorAll('[data-customer-photos]').forEach(gallery => {
      if (gallery.dataset.initialized) return;
      gallery.dataset.initialized = 'true';
      const links = [...gallery.querySelectorAll('[data-customer-photo]')];
      const dialog = gallery.querySelector('dialog');
      const image = gallery.querySelector('[data-customer-enlarged]');
      let active = 0, opener;
      const show = index => {
        active = (index + links.length) % links.length;
        image.src = links[active].href;
        image.alt = links[active].querySelector('img').alt;
        gallery.querySelector('[data-photo-position]').textContent = `${active + 1} / ${links.length}`;
      };
      links.forEach((link,index) => link.addEventListener('click',event => {
        event.preventDefault(); opener = link; show(index); dialog.showModal();
      }));
      gallery.querySelector('[data-photo-close]').addEventListener('click',()=>dialog.close());
      gallery.querySelector('[data-photo-prev]').addEventListener('click',()=>show(active-1));
      gallery.querySelector('[data-photo-next]').addEventListener('click',()=>show(active+1));
      dialog.addEventListener('keydown',event=>{
        if(event.key==='ArrowRight'){event.preventDefault();show(active+1);}
        if(event.key==='ArrowLeft'){event.preventDefault();show(active-1);}
      });
      dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
      dialog.addEventListener('close',()=>opener?.focus({preventScroll:true}));
    });
    scope.querySelectorAll('[data-pb-reviews]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const cards = [...root.querySelectorAll('.pb-review-card')];
      const button = root.querySelector('[data-review-more]');
      const status = root.querySelector('[data-review-count]');
      let matching = cards;
      let visible = Math.min(6, matching.length);
      const filters = root.querySelector('.pb-review-filters');
      if (filters) filters.hidden = false;
      const update = () => {
        cards.forEach(card => { card.hidden = !matching.slice(0, visible).includes(card); });
        button.hidden = visible >= matching.length;
        status.textContent = `${matching.length} yorumdan ${visible} tanesi gösteriliyor.`;
      };
      button.addEventListener('click', () => {
        const firstNew = matching[visible];
        visible = Math.min(visible + 6, matching.length);
        update();
        firstNew?.focus({ preventScroll: true });
      });
      root.querySelectorAll('[data-review-filter]').forEach(filter => {
        filter.addEventListener('click', () => {
          const topic = filter.dataset.reviewFilter;
          matching = topic === 'all' ? cards : cards.filter(card => card.dataset.reviewTopics.split(' ').includes(topic));
          visible = Math.min(6, matching.length);
          root.querySelectorAll('[data-review-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === filter)));
          update();
        });
      });
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
